module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radio"
  }, [_c('input', {
    staticClass: "radio__input",
    attrs: {
      "type": "radio",
      "id": _vm.id,
      "required": _vm.required,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.value,
      "checked": _vm.shouldBeChecked
    },
    on: {
      "change": _vm.updateInput
    }
  }), (_vm.label) ? _c('label', {
    staticClass: "radio__label",
    attrs: {
      "for": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7617df1c","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/Radio.vue
// module id = 778e871af2e804c10af8
// module chunks = 89